import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=a1cc935c&"
import script from "./TabNav.vue?vue&type=script&lang=js&"
export * from "./TabNav.vue?vue&type=script&lang=js&"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=a1cc935c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports